import Button from "@mui/material/Button";

const CustomizedButton = ({
  sx,
  variant,
  title,
  onClick,
  startIcon,
  type,
  fullWidth,
  color,
  size,
  disabled,
  id,
  testId,
}) => {
  return (
    <Button
      id={id}
      data-test-id={testId}
      sx={sx}
      type={type || "button"}
      size={size || "small"}
      variant={variant}
      onClick={onClick}
      startIcon={startIcon}
      fullWidth={fullWidth}
      color={color}
      disabled={disabled}
      formNoValidate
    >
      {title}
    </Button>
  );
};

export default CustomizedButton;
